import { render } from "./SectionSidebar.vue?vue&type=template&id=bbe7754e&scoped=true"
import script from "./SectionSidebar.vue?vue&type=script&lang=js"
export * from "./SectionSidebar.vue?vue&type=script&lang=js"

import "./SectionSidebar.vue?vue&type=style&index=0&id=bbe7754e&scoped=true&lang=css"

import exportComponent from "/builds/qes-dev/qes-apps/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe7754e"]])

export default __exports__